import React from 'react'
import AdminNavbar from "../Navbars/AdminNavbar.js";
import AdminSidebar from '../Sidebar/AdminSidebar';
import { SuperAdminApis } from '../../apis/superAdminApi';
import { AxiosResponse } from 'axios';
import { useSelector } from 'react-redux';
import { Oval } from 'react-loader-spinner';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';

export default function CalculateRate() {

  const [result, setResult] = React.useState<any>(null);
  const [countryTo, setCountryTo] = React.useState<any>([]);
  const [stateFrom, setStateFrom] = React.useState<any>([]);
  const [stateTo, setStateTo] = React.useState<any>([]);
  const [lgaFrom, setLgaFrom] = React.useState<any>([]);
  const [lgaTo, setLgaTo] = React.useState<any>([]);
  const [loader, setLoader] = React.useState<boolean>(false);

  const userLoginData = useSelector((state: any) => state.data.login.value);

  // Form data states
  const [countryToData, setCountryToData] = React.useState<any>('1'); // Default to Nigeria
  const [stateFromData, setStateFromData] = React.useState<any>('');
  const [stateToData, setStateToData] = React.useState<any>('');
  const [stateFromName, setStateFromName] = React.useState<string>(''); // NEW: Store state name
  const [stateToName, setStateToName] = React.useState<string>(''); // NEW: Store state name
  const [lgaFromData, setLgaFromData] = React.useState<any>('');
  const [lgaToData, setLgaToData] = React.useState<any>('');
  const [weight, setWeight] = React.useState<any>('');
  const [cubicWeight, setCubicWeight] = React.useState<any>('');
  const [serviceType, setServiceType] = React.useState<string>('domestic');

  // For cubic weight calculation
  const [length, setLength] = React.useState<any>('');
  const [width, setWidth] = React.useState<any>('');
  const [height, setHeight] = React.useState<any>('');

  React.useEffect(() => {
    loadInitialData();
  }, []);

  // Auto-calculate cubic weight when dimensions change
  React.useEffect(() => {
    if (length && width && height) {
      const cubic = (parseFloat(length) * parseFloat(width) * parseFloat(height)) / 5000;
      setCubicWeight(cubic.toFixed(2));
    } else {
      setCubicWeight('');
    }
  }, [length, width, height]);

  // Update service type when country changes
  React.useEffect(() => {
    if (countryToData && countryToData !== '1') {
      setServiceType('export');
    }
  }, [countryToData]);

  const loadInitialData = () => {
    // Load destination countries
    SuperAdminApis.getAllCountryTo('').then((response: AxiosResponse<any>) => {
      if (response?.data) {
        setCountryTo(response?.data);
      }
    });

    // Load origin states (ZoneState - for Nigeria)
    SuperAdminApis.getAllStateFrom('', {}).then((response: AxiosResponse<any>) => {
      if (response?.data) {
        setStateFrom(response?.data);
      }
    });

    // Load destination states (ZoneState)
    SuperAdminApis.getAllStateTo('', {}).then((response: AxiosResponse<any>) => {
      if (response?.data) {
        setStateTo(response?.data);
      }
    });
  };

  const getStateTo = React.useCallback((id: any) => {
    setCountryToData(id);
    setStateToData('');
    setStateToName('');
    setLgaToData('');
    setLgaTo([]);

    // Automatically set service type
    if (id !== '1') {
      setServiceType('export');
    } else {
      setServiceType('domestic');
    }

    // Load states (ZoneState)
    SuperAdminApis.getAllStateTo('', {}).then((response: AxiosResponse<any>) => {
      if (response?.data) {
        setStateTo(response?.data);
      }
    });
  }, []);

  // NEW: Determine LGA service type based on weight
  const getLgaServiceType = (currentWeight: string): string => {
    if (!currentWeight) return 'domestic';
    const weightNum = parseFloat(currentWeight);
    // Domestic: 0.5-10kg, Bulk: 20-999kg
    return weightNum >= 20 ? 'bulk' : 'domestic';
  };

  // NEW: Updated getLgaFrom using getLgasByState endpoint
  const getLgaFrom = React.useCallback((stateId: any, stateName: string) => {
    setStateFromData(stateId);
    setStateFromName(stateName);
    setLgaFromData('');
    setLgaFrom([]);

    if (!stateName) return;

    // Determine service type based on weight
    const lgaServiceType = getLgaServiceType(weight);

    // Use new endpoint with state_name
    SuperAdminApis.getLgasByState(stateName, lgaServiceType, '')
      .then((response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          setLgaFrom(response?.data?.data || []);
        } else {
          setLgaFrom([]);
        }
      })
      .catch((error) => {
        console.error('Error loading LGAs from:', error);
        setLgaFrom([]);
      });
  }, [weight]);

  // NEW: Updated getLgaTo using getLgasByState endpoint
  const getLgaTo = React.useCallback((stateId: any, stateName: string) => {
    setStateToData(stateId);
    setStateToName(stateName);
    setLgaToData('');
    setLgaTo([]);

    if (!stateName) return;

    // Determine service type based on weight
    const lgaServiceType = getLgaServiceType(weight);

    // Use new endpoint with state_name
    SuperAdminApis.getLgasByState(stateName, lgaServiceType, '')
      .then((response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          setLgaTo(response?.data?.data || []);
        } else {
          setLgaTo([]);
        }
      })
      .catch((error) => {
        console.error('Error loading LGAs to:', error);
        setLgaTo([]);
      });
  }, [weight]);

  // NEW: Reload LGAs when weight changes significantly (crosses thresholds)
  React.useEffect(() => {
    if (weight && stateFromName) {
      const weightNum = parseFloat(weight);
      // Reload if crossing the 20kg threshold
      if ((weightNum >= 20 && lgaFrom.length > 0) || (weightNum < 20 && lgaFrom.length > 0)) {
        getLgaFrom(stateFromData, stateFromName);
      }
    }
    if (weight && stateToName) {
      const weightNum = parseFloat(weight);
      if ((weightNum >= 20 && lgaTo.length > 0) || (weightNum < 20 && lgaTo.length > 0)) {
        getLgaTo(stateToData, stateToName);
      }
    }
  }, [weight]);

  const calculate = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    setResult(null);

    let data: any = {
      "country_from": 1, // Always Nigeria
      "country_to": parseInt(countryToData),
      "state_from": stateFromData || null,
      "state_to": stateToData,
      "lga_from": lgaFromData || 'empty',
      "lga_to": lgaToData || 'empty',
      "weight": parseFloat(weight),
      "service_type": serviceType
    };

    // Add cubic weight if provided
    if (cubicWeight && parseFloat(cubicWeight) > 0) {
      data.cubic_weight = parseFloat(cubicWeight);
    }

    SuperAdminApis.calculateRate(data).then((response: any) => {
      setLoader(false);
      if (response?.data?.status) {
        setResult(response?.data?.data);
        toast.success('Rate calculated successfully');
      } else {
        toast.warn(response?.response?.data?.message || 'Rate calculation failed');
      }
    }).catch((error) => {
      setLoader(false);
      toast.error(error?.response?.data?.message || 'An error occurred during calculation');
    });
  }, [countryToData, stateFromData, stateToData, lgaFromData, lgaToData, weight, cubicWeight, serviceType]);

  const getServiceTypeLabel = (type: string) => {
    switch (type) {
      case 'domestic_normal': return 'Domestic (0.5kg - 10kg)';
      case 'domestic_bulk': return 'Bulk (20.5kg - 50kg)';
      case 'domestic_bulk_extra': return 'Bulk Extra (51kg - 500kg)';
      case 'express': return 'Express Delivery for E-Commerce';
      case 'export': return 'International Export';
      default: return type;
    }
  };

  // NEW: Helper to display LGA rate info
  const getLgaRateInfo = (lga: any) => {
    if (!lga.onforwarding_value && !lga.add_1kg_value) return '';
    return ` (Base: ₦${parseFloat(lga.onforwarding_value || 0).toLocaleString()}, +₦${parseFloat(lga.add_1kg_value || 0).toLocaleString()}/kg)`;
  };

  return (
    <>
      <AdminSidebar title="Calculate Rate" />
      <div className="relative md:ml-64 bg-[#FAFAFA]">
        <AdminNavbar title="Calculate Rate" />

        <div className='lg:px-10 pb-6 px-6 pt-5 bg-[#FAFAFA] min-h-screen'>
          <div className='bg-white border border-[#E2E8F0] rounded-[10px] pt-[60px] pb-[40px] px-[23px]'>
            <form onSubmit={calculate}>

              {/* Origin Indicator */}
              <div className='mb-6 bg-green-50 border-l-4 border-green-500 rounded-lg p-4'>
                <div className='flex items-center space-x-3'>
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <p className='font-semibold text-sm text-green-800'>Origin Country: Nigeria</p>
                    <p className='text-xs text-green-600'>All shipments originate from Nigeria</p>
                  </div>
                </div>
              </div>

              {/* Service Type Selection - Only for domestic */}
              {countryToData === '1' && (
                <div className='mb-6'>
                  <h3 className='text-[16px] font-semibold mb-3'>Service Type (Domestic)</h3>
                  <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                    <label className={`flex items-center space-x-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${serviceType === 'domestic' ? 'border-[#E04343] bg-red-50' : 'border-gray-200'}`}>
                      <input
                        type="radio"
                        name="serviceType"
                        value="domestic"
                        checked={serviceType === 'domestic'}
                        onChange={(e) => setServiceType(e.target.value)}
                        className="w-4 h-4 text-[#E04343]"
                      />
                      <div>
                        <p className='font-semibold text-sm'>Domestic</p>
                        <p className='text-xs text-gray-500'>Standard delivery</p>
                      </div>
                    </label>

                    <label className={`flex items-center space-x-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${serviceType === 'express' ? 'border-[#E04343] bg-red-50' : 'border-gray-200'}`}>
                      <input
                        type="radio"
                        name="serviceType"
                        value="express"
                        checked={serviceType === 'express'}
                        onChange={(e) => setServiceType(e.target.value)}
                        className="w-4 h-4 text-[#E04343]"
                      />
                      <div>
                        <p className='font-semibold text-sm'>Express</p>
                        <p className='text-xs text-gray-500'>Fast delivery</p>
                      </div>
                    </label>
                  </div>
                </div>
              )}

              {/* Export Service Indicator */}
              {countryToData !== '1' && (
                <div className='mb-6 bg-blue-50 border-l-4 border-blue-500 rounded-lg p-4'>
                  <div className='flex items-center space-x-3'>
                    <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <p className='font-semibold text-sm text-blue-800'>International Export</p>
                      <p className='text-xs text-blue-600'>Service type automatically set to Export</p>
                    </div>
                  </div>
                </div>
              )}

              {/* NEW: Enhanced LGA Rate Info Banner */}
              {countryToData === '1' && (
                <div className='mb-6 bg-yellow-50 border-l-4 border-yellow-500 rounded-lg p-4'>
                  <div className='flex items-start space-x-3'>
                    <svg className="w-5 h-5 text-yellow-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <p className='font-semibold text-sm text-yellow-800'>LGA Rate System</p>
                      <p className='text-xs text-yellow-700 mt-1'>
                        LGAs are loaded based on your weight selection:
                      </p>
                      <ul className='text-xs text-yellow-700 mt-2 ml-4 list-disc space-y-1'>
                        <li><strong>Weight 0.5-10kg:</strong> Domestic LGA rates with onforwarding charges</li>
                        <li><strong>Weight 20kg+:</strong> Bulk LGA rates for heavy shipments</li>
                        <li>Enter weight first, then select state to see available LGAs</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {/* Shipment Information - MOVED UP so weight is entered first */}
              <div className='grid md:grid-cols-4 gap-3'>
                <div>
                  <h3 className='text-[16px] font-semibold mt-7'>Shipment Information</h3>
                  <p className='text-xs text-gray-500 mt-1'>Enter weight first to see correct LGAs</p>
                </div>

                <div className="w-full">
                  <div className="relative w-full mb-5">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      Dead Weight (KG) <span className='text-red-400'>*</span>
                    </label>
                    <input
                      type="number"
                      step="0.1"
                      min="0.1"
                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                      placeholder="Enter weight"
                      value={weight}
                      onChange={(e) => setWeight(e.target.value)}
                      required
                    />
                    <p className='text-xs text-blue-600 mt-1'>
                      {weight && parseFloat(weight) >= 20
                        ? '📦 Bulk weight - bulk LGA rates will be shown'
                        : '📦 Domestic weight - domestic LGA rates will be shown'}
                    </p>
                  </div>
                </div>

                <div className="w-full">
                  <div className="relative w-full mb-5">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      Length (cm) <span className='text-gray-400 font-thin'>(Optional)</span>
                    </label>
                    <input
                      type="number"
                      step="0.1"
                      min="0"
                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                      placeholder="Length"
                      value={length}
                      onChange={(e) => setLength(e.target.value)}
                    />
                  </div>
                </div>

                <div className="w-full">
                  <div className="relative w-full mb-5">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      Width (cm) <span className='text-gray-400 font-thin'>(Optional)</span>
                    </label>
                    <input
                      type="number"
                      step="0.1"
                      min="0"
                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                      placeholder="Width"
                      value={width}
                      onChange={(e) => setWidth(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className='grid md:grid-cols-4 gap-3 mt-1'>
                <div></div>

                <div className="w-full">
                  <div className="relative w-full mb-5">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      Height (cm) <span className='text-gray-400 font-thin'>(Optional)</span>
                    </label>
                    <input
                      type="number"
                      step="0.1"
                      min="0"
                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                      placeholder="Height"
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                    />
                  </div>
                </div>

                <div className="w-full">
                  <div className="relative w-full mb-5">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      Cubic Weight (KG)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="bg-gray-100 border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                      placeholder="Auto-calculated"
                      value={cubicWeight}
                      readOnly
                    />
                    <p className='text-xs text-gray-500 mt-1'>L × W × H ÷ 5000</p>
                  </div>
                </div>

                <div></div>
              </div>

              {/* Source Information */}
              <div className='grid md:grid-cols-4 gap-3 mt-5'>
                <div>
                  <h3 className='text-[16px] font-semibold mt-7'>Source Information</h3>
                  <p className='text-xs text-gray-500 mt-1'>Optional - for LGA charges</p>
                </div>

                <div className="w-full">
                  <div className="relative w-full mb-5">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      State <span className='text-gray-400 font-thin'>(Optional)</span>
                    </label>
                    <select
                      onChange={(e) => {
                        const selectedState = stateFrom?.data?.find((s: any) => s.id === parseInt(e.target.value));
                        if (selectedState) {
                          getLgaFrom(e.target.value, selectedState.state_name);
                        }
                      }}
                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                      disabled={!weight}
                    >
                      <option value="">--Select State--</option>
                      {stateFrom?.data?.map((datas: any) => (
                        <option key={datas?.id} value={datas?.id}>
                          {datas?.state_name} {datas?.zone_number ? `(Zone ${datas?.zone_number})` : ''}
                        </option>
                      ))}
                    </select>
                    {!weight && (
                      <p className='text-xs text-orange-500 mt-1'>⚠️ Enter weight first</p>
                    )}
                  </div>
                </div>

                <div className="w-full">
                  <div className="relative w-full mb-5">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      LGA <span className='text-gray-400 font-thin'>(Optional)</span>
                    </label>
                    <select
                      onChange={(e) => setLgaFromData(e.target.value)}
                      value={lgaFromData}
                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                      disabled={!stateFromData || lgaFrom.length === 0}
                    >
                      <option value="">--Select LGA--</option>
                      {lgaFrom.map((lga: any, index: number) => (
                        <option key={index} value={lga?.lga_name}>
                          {lga?.lga_name}{getLgaRateInfo(lga)}
                        </option>
                      ))}
                    </select>
                    {stateFromData && lgaFrom.length === 0 && (
                      <p className='text-xs text-gray-500 mt-1'>No LGAs for this weight/state combo</p>
                    )}
                  </div>
                </div>

                <div></div>
              </div>

              {/* Destination Information */}
              <div className='grid md:grid-cols-4 gap-3 mt-5 md:mt-1'>
                <div>
                  <h3 className='text-[16px] font-semibold mt-7'>Destination Information</h3>
                  <p className='text-xs text-gray-500 mt-1'>Required for rate calculation</p>
                </div>

                <div className="w-full">
                  <div className="relative w-full mb-5">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      Country <span className='text-red-400'>*</span>
                    </label>
                    <select
                      onChange={(e) => getStateTo(e.target.value)}
                      value={countryToData}
                      required
                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 cursor-pointer"
                    >
                      <option value="">--Select Country--</option>
                      <option value="1">Nigeria (Domestic)</option>
                      {countryTo?.data?.filter((data: any) => data?.id !== 1)?.map((datas: any) => (
                        <option key={datas?.id} value={datas?.id}>{datas?.country_name}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="w-full">
                  <div className="relative w-full mb-5">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      State <span className='text-red-400'>*</span>
                    </label>
                    <select
                      required
                      onChange={(e) => {
                        const selectedState = stateTo?.data?.find((s: any) => s.id === parseInt(e.target.value));
                        if (selectedState) {
                          getLgaTo(e.target.value, selectedState.state_name);
                        }
                      }}
                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                      disabled={!weight}
                    >
                      <option value="">--Select State--</option>
                      {stateTo?.data?.map((datas: any) => (
                        <option key={datas?.id} value={datas?.id}>
                          {datas?.state_name} {datas?.zone_number ? `(Zone ${datas?.zone_number})` : ''}
                        </option>
                      ))}
                    </select>
                    {!weight && (
                      <p className='text-xs text-orange-500 mt-1'>⚠️ Enter weight first</p>
                    )}
                  </div>
                </div>

                <div className="w-full">
                  <div className="relative w-full mb-5">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      LGA <span className='text-gray-400 font-thin'>(Optional)</span>
                    </label>
                    <select
                      onChange={(e) => setLgaToData(e.target.value)}
                      value={lgaToData}
                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                      disabled={!stateToData || lgaTo.length === 0}
                    >
                      <option value="">--Select LGA--</option>
                      {lgaTo.map((lga: any, index: number) => (
                        <option key={index} value={lga?.lga_name}>
                          {lga?.lga_name}{getLgaRateInfo(lga)}
                        </option>
                      ))}
                    </select>
                    {stateToData && lgaTo.length === 0 && (
                      <p className='text-xs text-gray-500 mt-1'>No LGAs for this weight/state combo</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="w-full mt-4">
                <button
                  type='submit'
                  disabled={loader}
                  className='bg-[#E04343] text-white py-[10px] rounded-[42px] w-full disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#c73838] transition'
                >
                  <div className="flex justify-center gap-3">
                    <span>Calculate Rate</span>
                    <Oval
                      visible={loader}
                      height="20"
                      width="20"
                      color="#ffffff"
                      secondaryColor="#FCBF94"
                      ariaLabel="oval-loading"
                    />
                  </div>
                </button>
              </div>
            </form>
          </div>

          {/* Results Summary */}
          {result && (
            <div className='bg-white border border-[#E2E8F0] rounded-[10px] pt-[20px] pb-[10px] px-[23px] mt-[20px]'>
              <div className='flex justify-between items-center mb-2'>
                <h3 className='text-[16px] text-[#263238] font-medium'>Rate Summary</h3>
                <span className='text-xs bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-semibold'>
                  {getServiceTypeLabel(result?.service_type)}
                </span>
              </div>
              <p className='mt-1 text-[13px] text-[#808080]'>
                The total cost includes base rate, additional charges, and 7.5% VAT
              </p>
              <hr className='mt-2 mb-3' />

              {/* Service-specific details */}
              {result?.zone && (
                <div className='flex justify-between mb-2'>
                  <h3 className='text-[#808080] text-[14px]'>Zone</h3>
                  <h4 className='text-[#808080] text-[14px] font-semibold'>Zone {result.zone}</h4>
                </div>
              )}

              {result?.category && (
                <div className='flex justify-between mb-2'>
                  <h3 className='text-[#808080] text-[14px]'>Delivery Category</h3>
                  <h4 className='text-[#808080] text-[14px] font-semibold'>{result.category}</h4>
                </div>
              )}

              {result?.country && (
                <div className='flex justify-between mb-2'>
                  <h3 className='text-[#808080] text-[14px]'>Destination Country</h3>
                  <h4 className='text-[#808080] text-[14px] font-semibold'>{result.country}</h4>
                </div>
              )}

              {/* Weight information */}
              <div className='flex justify-between mb-2'>
                <h3 className='text-[#808080] text-[14px]'>Chargeable Weight</h3>
                <h4 className='text-[#808080] text-[14px] font-semibold'>{result?.actual_weight} kg</h4>
              </div>

              {/* Cost breakdown */}
              {result?.base_cost !== undefined && (
                <div className='flex justify-between mb-2'>
                  <h3 className='text-[#808080] text-[14px]'>Base Cost</h3>
                  <h4 className='text-[#808080] text-[14px]'>
                    {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(result?.base_cost || 0)}
                  </h4>
                </div>
              )}

              {result?.additional_cost > 0 && (
                <div className='flex justify-between mb-2'>
                  <h3 className='text-[#808080] text-[14px]'>Additional Cost</h3>
                  <h4 className='text-[#808080] text-[14px]'>
                    {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(result.additional_cost)}
                  </h4>
                </div>
              )}

              {/* NEW: Enhanced LGA Charges Display */}
              {result?.lga_charges > 0 && (
                <div className='bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-2'>
                  <div className='flex justify-between mb-1'>
                    <h3 className='text-[#856404] text-[14px] font-semibold'>LGA Charges</h3>
                    <h4 className='text-[#856404] text-[14px] font-bold'>
                      {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(result.lga_charges)}
                    </h4>
                  </div>
                  <p className='text-xs text-yellow-700 mt-1'>
                    Location-based charges: onforwarding value + (extra weight × per-kg rate)
                  </p>
                </div>
              )}

              {result?.onforwarding_charge > 0 && (
                <div className='flex justify-between mb-2'>
                  <h3 className='text-[#808080] text-[14px]'>Onforwarding Charge</h3>
                  <h4 className='text-[#808080] text-[14px]'>
                    {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(result.onforwarding_charge)}
                  </h4>
                </div>
              )}

              <div className='flex justify-between mb-2'>
                <h3 className='text-[#808080] text-[14px]'>Subtotal</h3>
                <h4 className='text-[#808080] text-[14px]'>
                  {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(result?.subtotal || 0)}
                </h4>
              </div>

              <div className='flex justify-between mb-2'>
                <h3 className='text-[#808080] text-[14px]'>VAT (7.5%)</h3>
                <h4 className='text-[#808080] text-[14px]'>
                  {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(result?.tax || 0)}
                </h4>
              </div>

              <hr className='mt-4 mb-3' />

              <div className='flex justify-between mb-2'>
                <h3 className='text-[#E04343] text-[16px] font-semibold'>Total Cost</h3>
                <h4 className='text-[#E04343] text-[24px] font-bold'>
                  {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(result?.total_cost || 0)}
                </h4>
              </div>

              {/* Custom rate indicator */}
              {result?.is_custom_rate && (
                <div className='mt-3 bg-purple-50 border border-purple-200 rounded-lg p-3'>
                  <div className='flex items-center space-x-2'>
                    <svg className="w-5 h-5 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                    <p className='text-sm text-purple-800 font-semibold'>
                      This is a custom rate for your account
                    </p>
                  </div>
                </div>
              )}

              {/* Rate Calculation Note */}
              <div className='mt-4 bg-gray-50 border border-gray-200 rounded-lg p-3'>
                <p className='text-xs text-gray-600'>
                  <strong>Note:</strong> This rate is calculated based on the destination zone, service type,
                  and weight. {result?.lga_charges > 0 ? 'LGA charges are calculated from weight ranges (base weight to upper weight) with onforwarding value and per-kg rates.' : ''}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}